import React from 'react';
import { colors } from '@this/shared/ui/theme/tokens/primitive-tokens/colors';
import { getCommonStyles } from './commonStyles';

interface AgreementCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  isApplicantConfirmed?: boolean;
  onApplicantConfirmedChange?: (checked: boolean) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

export const AgreementCheckbox: React.FC<AgreementCheckboxProps> = ({
  checked,
  onChange,
  isApplicantConfirmed,
  onApplicantConfirmedChange,
  disabled = false,
  style = {}
}) => {
  const styles = getStyles(disabled, style);

  return (
    <div style={styles.outerContainer}>
      <div style={styles.innerContainer}>
        <input
          type="checkbox"
          id="agreement"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          disabled={disabled}
          style={styles.checkbox}
        />
        <label htmlFor="agreement" style={styles.label}>
          <a href="https://aitravel.cloud/tos/" target="_blank" rel="noopener noreferrer" style={styles.link}>
            利用約款
          </a>
          、
          <a
            href="https://d14vxaqxdw6ji3.cloudfront.net/images/travel_terms.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            旅行業約款
          </a>
          ・
          <a
            href="https://d14vxaqxdw6ji3.cloudfront.net/images/requirements.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            手配旅行条件書
          </a>
          、
          <a
            href="https://transferdata.co.jp/privacy-policy#a"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            プライバシーポリシー
          </a>
          に同意する
        </label>
      </div>

      {onApplicantConfirmedChange && (
        <div style={{ ...styles.innerContainer, marginTop: '12px' }}>
          <input
            type="checkbox"
            id="applicant-confirm"
            checked={isApplicantConfirmed || false}
            onChange={e => onApplicantConfirmedChange(e.target.checked)}
            disabled={disabled}
            style={styles.checkbox}
          />
          <label htmlFor="applicant-confirm" style={styles.label}>
            私は本申込における申込者（または代理人）です
          </label>
        </div>
      )}
    </div>
  );
};

function getStyles(disabled: boolean, customStyle: React.CSSProperties) {
  const commonStyles = getCommonStyles();

  return {
    outerContainer: {
      ...commonStyles.message.confirm.container,
      ...customStyle
    } as React.CSSProperties,
    innerContainer: {
      display: 'flex',
      alignItems: 'center'
    } as React.CSSProperties,
    checkbox: {
      marginRight: '8px',
      flexShrink: 0,
      ...(disabled ? { opacity: 0.6 } : {})
    } as React.CSSProperties,
    label: {
      cursor: disabled ? 'default' : 'pointer',
      ...(disabled ? { opacity: 0.6 } : {})
    } as React.CSSProperties,
    link: {
      color: colors.blue[600],
      textDecoration: 'underline'
    } as React.CSSProperties
  };
}
